import { useContext } from 'react'

import { ProjectContext, type IProjectContextModel } from './ProjectContext'

const useProject = (): IProjectContextModel => {
  return useContext(ProjectContext)
}

export default useProject
